import { type FC, Fragment } from 'react';

import Checkmark from '@crehana/icons/outline/Checkmark';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';
import { clsx } from 'clsx';

import { Divisor, HighlightParagraph } from './Stepper.styles';

const { baseLighter, primaryLight } = colors;
interface StepperProps {
  steps: string[];
  isDark?: boolean;
  currentStep?: number;
}

const Stepper: FC<StepperProps> = ({ steps, isDark = false, currentStep }) => {
  return (
    <div className="flex items-center justify-center w-full">
      {steps.map((step, i) => {
        const isActiveStep = currentStep === i + 1;
        const isStepComplete = Number(currentStep) >= i + 1;
        return (
          <Fragment key={`step-${step}`}>
            <div className="flex flex-col md:flex-row  items-center justify-center">
              <div
                className={clsx(
                  'tw-flex tw-items-center tw-shrink-0 tw-justify-center tw-rounded-full tw-w-[28px] tw-h-[28px] tw-border-solid tw-border tw-text-neutral-light-700 tw-bg-neutral-light-100',
                  isActiveStep
                    ? 'tw-border-primary-light-500 tw-text-primary-light-500 dark:tw-text-[#878FB8] tw-bg-primary-light-100 dark:tw-bg-[#4F5374]'
                    : 'tw-border-neutral-light-500',
                  isStepComplete && 'tw-border-primary-light-500',
                )}
              >
                {currentStep && currentStep > i + 1 ? (
                  <Checkmark
                    size={16}
                    color={isDark ? baseLighter : primaryLight}
                  />
                ) : (
                  <p className="font-subtitle4 leading-none">{i + 1}</p>
                )}
              </div>
              <HighlightParagraph
                isDark={isDark}
                isActive={isActiveStep}
                className="font-subtitle4 mx-12"
              >
                {step}
              </HighlightParagraph>
            </div>
            {i + 1 < steps.length && (
              <Divisor isDark={isDark} className="mr-12" />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
